// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 568px) {\n.chart-data-item-mobile .m-section {\n    margin: 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
